import { atom } from 'recoil';

export const filterProject = atom({
  key: 'filterProject',
  default: {
    keyword: '',
    status: '',
  },
});
